import { useEffect, useState } from 'react';

const Footer = () => {
  const [reachOutNumber, setReachOutNumber] = useState('+1-800-MANGO');

  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/settings`)
      .then(res => res.json())
      .then(data => setReachOutNumber(data.reach_out_number))
      .catch(err => console.error('Failed to fetch settings:', err));
  }, []);

  return (
    <footer className="bg-[#FFF1E5] border-t-4 border-[#FFEAB3] py-12 mt-24" data-testid="main-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <h2 className="brand-logo text-3xl mb-4" data-testid="footer-brand-logo">Mango Cosmetics</h2>
          <p className="text-[#7D5A35] mb-4 font-['Nunito'] text-lg" data-testid="footer-tagline">
            Natural lip care with a fruity twist 🥭
          </p>
          <div className="space-y-2">
            <p className="text-[#3A1C00] font-bold font-['Fredoka']" data-testid="footer-contact-label">Contact Us:</p>
            <p className="text-[#7D5A35] text-lg font-medium" data-testid="footer-reach-out-number">{reachOutNumber}</p>
          </div>
          <div className="mt-8 text-sm text-[#7D5A35]" data-testid="footer-copyright">
            © 2026 Mango Cosmetics. All rights reserved.
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;